<template>
<div>
  <mv-tabs :tabsHeaders="tabsHeaders" @tabs="tabs = $event">
    <template #leftContainer0>
      <FilterTravelContributor @search="search"></FilterTravelContributor>
    </template>
    <template #tab0>
      <CollaboratorTableTravelExpense :isConsulta="true" v-if="tabs === 0" ref="CollaboratorTableTravelExpenseRef"/>
    </template>

    <template #leftContainer1>
      <FilterLotsPaid @search="search"></FilterLotsPaid>
    </template>
    <template #tab1>
      <LotsPaid :isConsulta="true" v-if="tabs === 1" ref="LotsPaidRef"/>
    </template>
  </mv-tabs>
</div>
</template>

<script>
import FilterTravelContributor from './components/FilterTravelsContributor/FilterTravelsContributor.vue'
import FilterLotsPaid from './components/Tabs/LotsPaid/components/filterLotsPaid.vue'
import CollaboratorTableTravelExpense from './components/Tabs/CollaboratorTableTravelExpense/CollaboratorTableTravelExpense.vue'
import LotsPaid from './components/Tabs/LotsPaid/LotsPaid.vue'
import MvTabs from './components/MvTabs/MvTabs.vue'
import ActionsForm from '@/shared/mixins/actionsForm'

// Tela de CONSULTA de Despesa Viagem (perfil ACC_ZPAG_VIAGEM_CONSULTA).
// Read-only: expoe apenas as abas Colaboradores e Lotes Pagos (isConsulta=true zera as acoes de
// escrita dentro de cada componente). Par da tela de consulta de Despesas Diversos. O escopo por
// empresa e travado no backend (ContaEmpresa).
export default {
  name: 'TravelExpenseZpagConsulta',
  components: { FilterTravelContributor, FilterLotsPaid, CollaboratorTableTravelExpense, LotsPaid, MvTabs },
  mixins: [ActionsForm],
  data () {
    return {
      tabs: 0,
      tabsHeaders: [
        {title: 'Colaboradores', icon: 'fas fa-user'},
        {title: 'Lotes Pagos', icon: 'fa fa-table'}
      ]
    }
  },
  methods: {
    search (data) {
      if (this.tabs === 0) {
        this.$refs.CollaboratorTableTravelExpenseRef.dataSearch = data
        this.$refs.CollaboratorTableTravelExpenseRef.Onload()
      }
      if (this.tabs === 1) {
        this.$refs.LotsPaidRef.dataSearch = data
        this.$refs.LotsPaidRef.Onload()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelexpensezpag/travelexpensezpagconsulta.vue